import React, { useEffect, useRef, useState } from 'react';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import { Done, Search } from '@material-ui/icons';

import { wsFindBy, wsCreate } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { TextField } from '@material-ui/core';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Código', accessor: 'AcctCode', width: 150 },
  { Header: 'Nombre de cuenta', accessor: 'AcctName' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function ModalAccount(props) {
  const { open, setOpen, showNotify, reload } = props;

  const acctCodeRef = useRef(null);
  const acctNameRef = useRef(null);
  const [accounts, setAccounts] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  function enter(e) {
    if (e.charCode == 13) {
      search();
    }
  }

  function search() {
    let params = {};
    if (!!acctCodeRef.current?.value) {
      params.AcctCode = acctCodeRef.current.value;
    }
    if (!!acctNameRef.current?.value) {
      params.AcctName = acctNameRef.current.value;
    }
    listAccounts(params);
  }

  async function listAccounts(params = {}) {
    setDataLoading(true);
    let response = await wsFindBy('pymt/account-sap/search', params);
    setDataLoading(false);
    if (response.success) setAccounts(response.data);
  }

  useEffect(() => {
    if (open) listAccounts();
  }, [open]);

  return (
    <ModalFull
      title="Guardar Cuenta"
      open={open}
      setOpen={setOpen}
    >
      <Card>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} sm={5} lg={3}>
              <TextField
                label="Código"
                fullWidth
                type="text"
                margin="normal"
                name="AcctCode"
                defaultValue=""
                inputRef={acctCodeRef}
                onKeyPress={enter}
              />
            </GridItem>
            <GridItem xs={12} sm={5} lg={3}>
              <TextField
                label="Nombre"
                fullWidth
                type="text"
                margin="normal"
                name="AcctName"
                defaultValue=""
                inputRef={acctNameRef}
                onKeyPress={enter}
              />
            </GridItem>
            <GridItem xs={6} sm={2}>
              <Button justIcon round color="primary" onClick={search} disabled={dataLoading}>
                <Search />
              </Button>
              {(dataLoading || saving) && <LoadingSpinner />}
            </GridItem>
          </GridContainer>

          <ReactTable
            key={accounts}
            defaultWidth={900}
            exportExcel={false}
            columns={columns}
            data={accounts.map((account, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <Button
                      justIcon
                      size="sm"
                      round
                      color={props.themeContext.buttonColorSuccess}
                      disabled={saving}
                      onClick={async () => {
                        setSaving(true);
                        let res = await wsCreate('pymt/account-sap', {
                          account: account.AcctCode,
                          description: account.AcctName,
                        });
                        setSaving(false);
                        if (res.success) {
                          showNotify(res.message || `Cuenta ${account.AcctCode} guardada`);
                          setOpen(false);
                          reload();
                        } else {
                          showNotify(res.message, 'error');
                        }
                      }}
                      style={{ marginLeft: '8px' }}
                    >
                      <Done />
                    </Button>
                  </div>
                ),
                AcctCode: account.AcctCode,
                AcctName: account.AcctName,
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </ModalFull>
  );
});
